// extracted by mini-css-extract-plugin
export default {"tx":"_19a4a8e554","line":"_7e62033b6a"};